import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Input from '@mui/material/Input';
import Tooltip from '@mui/material/Tooltip';

import EditIcon from "@mui/icons-material/Edit";

import { modifyOrderNote } from '../../pages/Orders/ordersSlice';

const OrderNote = ({ orderid, docid,notesData,meta }) => {
    const dispatch = useDispatch();
    const [notes, setNotes] = useState(notesData)
    const [modalVisible, setModalVisible] = useState(false);
    const profile = useSelector(state => state.auth.profile);   
    const onModalClose = () => {
        setModalVisible(false)
    }
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        bgcolor: 'background.paper'
    };
    const handleSubmit = () => {
            let data={
                "orderid":orderid,
                "order_note":notes,
                "docid":docid
            }
            dispatch(modifyOrderNote(profile && profile.id,data,meta))
            setModalVisible(false)
        }

    return (
        <>
        <Modal
                open={modalVisible}
                onClose={onModalClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Card sx={{ minWidth: 400 }} className="sc--cardhead--details">
                        <CardHeader title='Order Note' />
                        <Divider />
                        <CardContent>
                            <div className="sc--form--center" style={{ margin: '20px 0' }}>
                                <TextField
                                    label="Note"
                                    name="note"
                                    defaultValue={notes}
                                    onInput={e => setNotes(e.target.value)}
                                    style={{ width: "100%", margin: '8px' }}
                                     id="outlined-start-adornment"
                                    slotProps={{
                                        input: {
                                          startAdornment: <InputAdornment position="end"><EditIcon /></InputAdornment>,
                                        },
                                      }}
                                />
                           
                            </div>
                            <div className="sc--form--center" style={{ margin: '30px 0' }}>
                                <Button variant="outlined" onClick={handleSubmit}>Submit</Button>
                            </div>
                        </CardContent>
                    </Card>
                </Box>
            </Modal >
            <Tooltip title={notes} placement="top-start">
            <FormControl sx={{ m: 1, width: '25ch' }} variant="standard">
                    <InputLabel htmlFor="standard-adornment-password">Note</InputLabel>
                    <Input
                        id="standard-adornment-password"
                        type={'text'}
                        value={notes}
                        onClick={() => {
                            setModalVisible(true)
                        }}
                        endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => {
                                setModalVisible(true)
                            }}
                            >
                            <EditIcon style={{ color: 'rgb(25, 118, 210)' }}/> 
                            </IconButton>
                        </InputAdornment>
                        }
                    />
            </FormControl>
            </Tooltip>
        </>
    )
};

export default OrderNote;
